import React, {
  useEffect,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import ClassIcon from 'assets/images/icon/ClassIcon';
import CloseIcon from 'assets/images/icon/CloseIcon';
import CoachingIcon from 'assets/images/icon/CoachingIcon';
import StarFill from 'assets/images/icon/Star_fill';
import StarEmpty from 'assets/images/icon/StarEmpty';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { FaUser } from 'react-icons/fa6';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import { CheckBox } from 'view/components/common/CheckBox';

const arr = [1, 2, 3, 4, 5];

const ReviewPopup = (props) => {
    const [reviewData, setReviewData] = useState(null);
    const [ratingValue, setRatingValue] = useState(0);
    const [status, setStatus] = useState(false);
    const [selectItem, setSelectItem] = useState(null);
    const [feedback, setFeedback] = useState("");
    const mouseOver = (index) => {
        // setRatingValue(index);
    };
    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const getReviewById = async () => {
        await communicationAPI.getReviewById(props?.data?.id).then((res) => {
            console.log("res", res);
            setReviewData(cloneDeep(res?.data));
        });
    };

    const getFormData = () => {
        const formData = new FormData();

        // formData.append("email", props?.userData?.email);
        formData.append("content", feedback);

        return formData;
    };

    const putHomework = async () => {
        await communicationAPI
            .putReview(props?.data?.id, {
                data: {
                    answer: feedback,
                    completed: true,
                },
            })
            .then((res) => {
                console.log("suc", res);
                getReviewById();
                props.onClickGetData();
            });
    };

    useEffect(() => {
        setFeedback(props?.data?.reviewComments[0]?.content);
    }, [props?.data?.reviewComments[0]?.content]);

    useEffect(() => {
        if (!isEmpty(props?.data?.rating)) {
            setRatingValue(props?.data?.rating - 1);
        }
    }, [props?.data?.rating]);

    useEffect(() => {
        getReviewById();
    }, []);

    console.log("props?.data", props?.data);
    console.log("reviewData", reviewData);

    return (
        <Container>
            <Title>
                <h1>Your Feedback</h1>
                <CloseButton
                    onClick={() => {
                        props.onClickPopup();
                    }}
                >
                    <CloseIcon />
                </CloseButton>
            </Title>
            <div className={"wrap"} style={{ background: "#fff", paddingBottom:20 }}>
                <Contents>
                    <TextArea>
                         {/*<h2>{props?.data?.title || "Title"}</h2>*/}
                        {/* <Dvider /> */}
                        <TextAreaContents>
                            <Avatar>
                                {!isEmpty(props?.data?.user?.profileImage?.url) ? (
                                    <img
                                        src={
                                            props?.data?.user?.profileImage?.url ||
                                            "/images/userFeedback.png"
                                        }
                                        alt=""
                                    />
                                ) : (
                                    <FaUser />
                                )}
                            </Avatar>
                            <TextWrap >
                                <span>
                                    {props?.data?.user?.lastName || "Test"}&nbsp;
                                    {props?.data?.user?.firstName || ""}
                                </span>
                                <b>{returnData(props?.data?.createdDatetime) || "JUL 18, 2024"}</b>
                            </TextWrap>
                            {props?.data?.contentType !== "Coaching" ? (
                                <IconItem className={"wide"}>
                                    <ClassIcon />
                                    <span>Classes</span>
                                </IconItem>
                            ) : (
                                <IconItem className={"wide"}>
                                    <CoachingIcon />
                                    <span>Coaching</span>
                                </IconItem>
                            )}
                        </TextAreaContents>
                        <Stars className={"wide"}>
                            {arr.map((item, index) => (
                                <Star
                                    onMouseOver={() => {
                                        if (props?.data?.completed === true) return;
                                        mouseOver(index);
                                    }}
                                >
                                    {index <= ratingValue ? <StarFill /> : <StarEmpty />}
                                </Star>
                            ))}
                        </Stars>
                    </TextArea>
                    <TextArea
                        className={"mobile"}
                    >
                        <TextAreaContents style={{

                        }}>
                            {props?.data?.contentType !== "Coaching" ? (
                                <IconItem
                                    style={{
                                        marginLeft:0,
                                        height:20
                                    }}
                                >
                                    <ClassIcon />
                                    <span>Classes</span>
                                </IconItem>
                            ) : (
                                <IconItem
                                    style={{
                                        marginLeft:0,
                                        height:20
                                    }}
                                >
                                    <CoachingIcon />
                                    <span>Coaching</span>
                                </IconItem>
                            )}
                        </TextAreaContents>
                        <Stars>
                            {arr.map((item, index) => (
                                <Star
                                    onMouseOver={() => {
                                        if (props?.data?.completed === true) return;
                                        mouseOver(index);
                                    }}
                                >
                                    {index <= ratingValue ? <StarFill /> : <StarEmpty />}
                                </Star>
                            ))}
                        </Stars>
                    </TextArea>
                    <p>
                        {reviewData?.review?.title}
                    </p>
                    <ContentsWrap>
                        <textarea readOnly={true} value={props?.data?.content || "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut."} />
                    </ContentsWrap>
                </Contents>
                <div
                    style={{
                        padding: "0 20px",
                    }}
                >
                    {!isEmpty(reviewData?.review?.reviewComments) && (
                        <CommentsList>
                            {!isEmpty(reviewData?.review?.reviewComments) &&
                                reviewData?.review?.reviewComments?.map((item, index) => {
                                    return (
                                        <CommentsItem>
                                            <CommentTitle>
                                                <TitleLeft>
                                                    <User>
                                                        <img
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                objectFit: "cover",
                                                            }}
                                                            src={"/images/banner-publish.png"}
                                                            alt=""
                                                        />
                                                    </User>
                                                    <UserInfo>
                                                        <span style={{ fontSize: 16 }}>
                                                            Savita John
                                                        </span>
                                                        <b style={{ fontSize: 12 }}>
                                                            {returnData(item?.updatedDatetime)}
                                                        </b>
                                                    </UserInfo>
                                                </TitleLeft>
                                                <TitleRight>
                                                    {/* <div
                                                    onClick={()=>{
                                                        deleteQnaItem(item?.id, )
                                                    }}
                                                >
                                                    <DeleteRedIcon />
                                                </div> */}

                                                    {/* <div
                                                    onClick={() => {
                                                        if (
                                                            !isEmpty(selectItem) &&
                                                            selectItem?.id === item.id
                                                        ) {
                                                            const c = cloneDeep(reviewData);
                                                            editQnaItem(item?.id, c?.qnaComments[index]?.answer)
                                                            setSelectItem(null);
                                                        } else {
                                                            setSelectItem(item);
                                                            getQnaById();
                                                        }
                                                    }}
                                                >
                                                    <EditIcon />
                                                </div> */}
                                                </TitleRight>
                                            </CommentTitle>
                                            <Comments>
                                                <textarea
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const c = cloneDeep(reviewData);
                                                        c.review.reviewComments[index].answer = value;
                                                        setReviewData(c);
                                                    }}
                                                    readOnly={
                                                        !(
                                                            !isEmpty(selectItem) &&
                                                            selectItem?.id === item.id
                                                        )
                                                    }
                                                    className={
                                                        !isEmpty(selectItem) &&
                                                        selectItem?.id === item.id
                                                            ? "on"
                                                            : ""
                                                    }

                                                    value={item?.content}
                                                ></textarea>
                                            </Comments>
                                        </CommentsItem>
                                    );
                                })}
                        </CommentsList>
                    )}

                </div>
                {reviewData?.review?.completed === false && (
                    <Rating>
                        <textarea
                            style={{ fontSize: 18 }}
                            placeholder={"Add your answer"}
                            readOnly={props?.data?.completed === true}
                            value={feedback}
                            onChange={(e) => {
                                setFeedback(e.target.value);
                            }}
                        />
                    </Rating>
                )}

                {reviewData?.review?.completed === false && (
                    <Send>
                        <CheckBoxWrap>
                            <CheckBox
                                state={status}
                                onClick={() => {
                                    setStatus((v) => !v);
                                }}
                            />
                            <p style={{ marginLeft: 5 }}>Mark as Complete</p>
                        </CheckBoxWrap>
                        <span
                            className={isEmpty(feedback) && status === false ? "off" : ""}
                            onClick={async () => {
                                if (isEmpty(feedback) && status === false) return;
                                await putHomework();
                            }}
                        >
                            Send
                        </span>
                    </Send>
                )}

            </div>
        </Container>
    );
};
export default ReviewPopup;

const Container = styled.div`
    width: 90%;
    max-width: 900px;
    overflow: hidden;
    border-radius: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);

    h1 {
        font-size: 28px;
        font-weight: 700;
    }
    & > div{
        
    }
    .wrap{
        @media screen and (max-width: 768px) {
            max-height: 600px;
            overflow-y: scroll;
        }
        @media screen and (max-width: 468px) {
            max-height: 500px;
            overflow-y: scroll;
        }
    }

    @supports (-webkit-touch-callout: none) {
        top: 40%;

    }
`;

const Title = styled.div`
    height: 50px;
    justify-content: space-between;
    background: #333;
    padding-right: 17px;
    display: flex;
    align-items: center;
    padding-left: 17px;
    h1 {
        font-weight: 700;
        font-size: 22px;
        color: #ddc160;
    }
`;

const Dvider = styled.div`
    width: 100%;
    background: #333;
    opacity: 0.1;
    height: 1px;
`;

const Contents = styled.div`
    padding: 20px;
    p{
        color: #333;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 0.5rem;
    }
`;
const Avatar = styled.div`
    min-width: 50px;
    width: 50px;
    margin-right: 25px;
    svg {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background: #ddd;
        path {
            fill: #eee;
        }
    }
    img {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        object-fit: contain;
        min-width: 50px;
        min-height: 50px;
    }
`;
const TextArea = styled.div`
    flex: 1;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    &.mobile{
        display: none;
    }
    @media screen and (max-width: 768px) {
        .wide{
            display: none;
        }
        &.mobile{
            display: flex;
            margin-bottom: 4px;
        }
    }
    h2 {
        line-height: 29px;
        padding: 15px;
        font-size: 22px;
        font-weight: 700;
    }
`;
const CloseButton = styled.div`
    background: #333;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover{
        svg{
            transition: all 0.2s;
            transform: scale(1.1);
        }
    }
    svg {
        width: 30px;
        height: 30px;
    }
`;
const TextAreaContents = styled.div`
    display: flex;
    align-items: center;
`;
const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 50px;

    span {
        font-size: 22px;
        font-weight: 600;
        line-height: 27.5px;
    }
    p {
        line-height: 28px;
        font-size: 18px;
        font-weight: 400;
    }
    b {
        opacity: 0.6;
        font-size: 14px;
        display: inline-block;
        margin-bottom: 4px;
        color: #33333399;
    }
`;
const Rating = styled.div`
    padding: 0px 20px 16px 20px;
    width: 100%;
    h4 {
        font-size: 22px;
        margin-bottom: 15px;
    }
    textarea {
        background: #f5f5f5;
        border: solid 1px #33333330;
        border-radius: 8px;
        width: 100%;
        height: 130px;
        outline: none;
        resize: none;
        padding: 15px;
    }
`;
const RatingHeader = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    h2 {
        font-size: 22px;
        margin-right: 30px;
    }
    span {
        b {
            width: 12px;
            font-weight: 400;
        }
        display: flex;
        height: 100%;
        padding-top: 3px;
        width: 54px;
    }
`;
const Stars = styled.div`
    display: flex;
    padding-top: 8px;
    align-items: flex-start;
`;
const Star = styled.div`
    display: flex;
    align-items: center;
    margin-right: 5px;
    cursor: pointer;
    svg{
        width: 20px;
        height: 20px;
    }
`;
const Send = styled.div`
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    width: 100%;
    @media screen and (max-width: 768px) {
        p{
            font-size: 14px;
        }
        
    }
    font-size: 18px;
    background: #fff;
    span {
        &.off {
            background: #ddd;
        }
        cursor: pointer;
        background: #ddc160;
        color: #fff;
        width: 134px;
        height: 40px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
    }
`;

const IconItem = styled.div`
    display: flex;
    padding-top: 8px;
    align-items: flex-start;
    margin-left: 20px;
    height: 60px;
    span {
        margin-left: 8px;
        padding-top: 4px;
    }
`;

const ContentsWrap = styled.div`
    max-height: 120px;
    height: 100px;
    //height: 120px;

    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
    textarea {
        border: none;
        height: 100%;
        width: 100%;
        resize: none;
        outline: none;
        color: #333;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        margin-bottom: 0;
        line-height: 28px;
        overflow-y: auto;
        position: relative;
    }
`;

const CheckBoxWrap = styled.div`
    display: flex;
    align-items: center;
`;

const CommentsList = styled.div`
    border-radius: 8px;
    max-height: 300px;
    border: solid 1px #3333333f;
    background: #f3f3f3;
    padding-bottom: 15px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    margin-bottom: 20px;
    @media screen and (max-width: 768px) {
        max-height: 120px;
    }
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const CommentsItem = styled.div`
    padding: 15px 15px 0 15px;
`;
const Comments = styled.div`
    margin-top: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    transition: all 0.2s;
    textarea {
        transition: all 0.2s;
        background: #f3f3f3;
        resize: none;
        width: 100%;
        border-radius: 8px;
        padding: 0;
        line-height: 22px;
        font-size: 15px;
        border: none;
        outline: none;
        &.on {
            padding: 5px 10px;
            background: #fff;
            border: solid 1px #333;
        }
    }
    p {
        line-height: 22px;
    }
`;
const CommentTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const User = styled.div`
    img {
        border-radius: 100%;
        margin-right: 10px;
    }
`;
const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    span {
        color: #333;
        font-weight: 700;
        margin-bottom: 2px;
    }
    b {
        color: #bbb;
    }
`;
const TitleLeft = styled.div`
    display: flex;
    align-items: center;
    & > div {
        height: 100%;
        display: flex;
        align-items: center;
    }
`;
const TitleRight = styled.div`
    height: 40px;
    display: flex;
    align-items: center;
    svg {
        cursor: pointer;
        margin-left: 16px;
    }
`;
